<template>
    <div>
        <Breadcrumbs main="Services" title="Account Officer"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
          <div v-if="loading" class="loader-12"></div>
            <div v-else class="user-profile">
              <div class="row">
                <div class="col-md-6 offset-sm-0 offset-md-3">
                <div class="card custom-card">
                    <div class="card-profile"><img class="rounded-circle" src="@/assets/TAJimages/dashboard/welcome.png" alt=""></div>
                    <div class="text-center profile-details">
                    <h4>{{accountOfficer.name ? accountOfficer.name : 'N/A'}}</h4>
                    <h6>Account Officer</h6>
                    </div>
                    <div class="card-footer row">
                        <div class="col-12  text-center col-sm-12">
                          <h6 class="text-dark">Phone Number</h6>
                          <h6><a :href="`tel:${accountOfficer.phoneNumber}`">{{accountOfficer.phoneNumber ? accountOfficer.phoneNumber : 'N/A'}}</a></h6>
                          <h6 class="text-dark mt-3">Email</h6>
                          <h6><a href="mailto:tajconnect@tajbank.com">tajconnect@tajbank.com</a></h6>
                        </div>
                    </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    data:() => ({
      loading: false,
    }),
    computed: {
      ...mapState({
        // eslint-disable-next-line no-confusing-arrow
        accountNumber: state => state.dashboard.dashboardData ? state.dashboard.dashboardData.accounts[0].accountNumber : 'N/A',
        accountOfficer: state => state.authentication.accountofficer,
      }),
    },
    mounted() {
      this.loading = true;
      this.$store.dispatch('dashboard/getDashboardData').then(response => {
        if(response.status === 200) {
          this.$store.dispatch('getAccountOfficer', this.accountNumber).then(response => {
            if(response.status === 200) {
              this.loading = false;
            }
          });
        }
      });
    }
  };
</script>
<style scoped>

.user-profile .hovercard .cardheader {
    background: url(../../assets/TAJimages/banner-bg8.jpeg);
    background-size: cover;
    background-position: 10%;
}
.avatar-image {
    margin: 0 auto;
    border-radius: 50%;
    background-color: #fff;
    height: 125px;
    width: 125px;
    margin-top: -50px !important;
    border: 1px solid #ecf3fa
}
</style>